import React from 'react';
import { BarChart3 } from 'lucide-react';
import { Formation } from '../data/constants';
type InserJeunesProps = {
  data: NonNullable<Formation['inserJeunes']>;
  /** Fond de la section : clair (cartes blanches) ou blanc (cartes grises) */
  surface?: 'light' | 'white';
};

/**
 * Indicateurs nationaux InserJeunes pour une formation donnée.
 * Publiés en complément de nos propres indicateurs, ils donnent des
 * repères concrets aux candidats et à leurs familles.
 */
export function InserJeunes({
  data,
  surface = 'white'
}: InserJeunesProps) {
  const cardBg = surface === 'white' ? 'bg-slate-50' : 'bg-white';
  return <div data-id="element-406" data-mp="32i8jtn1rf98q">
      <h3 className="flex items-center gap-2 text-xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-407" data-mp="32hgli4gs2xer">
        <BarChart3 className="w-5 h-5 text-primary shrink-0" data-id="element-408" data-mp="37f8phwup69zb" />
        Indicateurs nationaux (InserJeunes)
      </h3>

      <div className="grid sm:grid-cols-2 gap-5" data-id="element-409" data-mp="185aap6rsqimz">
        {/* Emploi à 6 mois */}
        <div className={`${cardBg} rounded-2xl p-6`} data-id="element-410" data-mp="1d2939kvtahj2">
          <p className="text-4xl font-extrabold font-heading text-brand-orange mb-2" data-id="element-411" data-mp="3rbdftg32hy2k">
            {data.emploi6Mois}
          </p>
          <p className="font-medium text-primary-dark leading-relaxed" data-id="element-412" data-mp="3miu4yqvrlh1g">
            apprenants sortants en emploi salarié 6 mois après leur sortie de
            formation
          </p>
        </div>

        {/* Poursuite / sortie */}
        <div className={`${cardBg} rounded-2xl p-6 flex flex-col justify-center`} data-id="element-413" data-mp="e4lhfx83ngg5">
          <div className="flex justify-between mb-3 text-sm" data-id="element-414" data-mp="e2hdxge44jge">
            <span className="font-bold text-primary-dark" data-id="element-415" data-mp="a41ico3yu2rd">
              {data.poursuiteEtudes} poursuivent leurs études
            </span>
            <span className="font-bold text-primary-dark" data-id="element-416" data-mp="55qb8l5226cu">
              {data.sortieFormation} sortent
            </span>
          </div>
          <div className="h-4 w-full bg-slate-200 rounded-full overflow-hidden flex" data-id="element-417" data-mp="2punuvog2pwfs">
            <div className="h-full bg-primary" style={{
            width: data.poursuiteEtudes
          }} data-id="element-418" data-mp="2kvb5avxtib9i" />
            <div className="h-full bg-brand-orange" style={{
            width: data.sortieFormation
          }} data-id="element-419" data-mp="2md9vrp7h7lgn" />
          </div>
        </div>

        {/* Rémunération */}
        <div className={`${cardBg} rounded-2xl p-6 text-center`} data-id="element-420" data-mp="2dah1re6wsvn4">
          <p className="font-bold text-primary-dark mb-3" data-id="element-421" data-mp="2ialnbimocgk7">
            Rémunération 1 an après la formation
          </p>
          <p className="text-2xl font-extrabold font-heading text-primary mb-1" data-id="element-422" data-mp="23lh0tp8ujq6a">
            Entre {data.remuneration}
          </p>
          <p className="text-sm text-muted-foreground" data-id="element-423" data-mp="28e0cggnz4b8g">
            pour 50 % des salariés
          </p>
        </div>

        {/* Ruptures */}
        <div className={`${cardBg} rounded-2xl p-6 flex flex-col justify-center`} data-id="element-424" data-mp="1ymct731km0i2">
          <p className="text-3xl font-extrabold font-heading text-primary-dark mb-2" data-id="element-425" data-mp="1yk9rvmuywky1">
            {data.rupture}
          </p>
          <p className="font-medium text-primary-dark leading-relaxed" data-id="element-426" data-mp="1pmhcyjt5rfb6">
            Part des contrats interrompus avant leur terme
          </p>
        </div>
      </div>

      <p className="text-xs text-muted-foreground mt-5" data-id="element-427" data-mp="161z8ttd94g6m">
        Source : InserJeunes (Ministère de l'Éducation nationale et de la
        Jeunesse). Moyennes nationales fournies à titre indicatif, distinctes
        des résultats propres à notre CFA.
      </p>
    </div>;
}